import { Map } from "maplibre-gl";
import { LayerParams } from "../../map/layer-manager";
import { MapLayer } from "../map-layer";

/**
 * Camada de destaque de um polígono.
 */
export class PolygonHighlightLayer extends MapLayer {

  constructor(private sourceId: string, private lineLayerId: string, private fillLayerId: string) {
    super();
  }

  remove(map: Map): void {

    if (map.getLayer(this.lineLayerId)) {
      map.removeLayer(this.lineLayerId);
    }

    if (map.getLayer(this.fillLayerId)) {
      map.removeLayer(this.fillLayerId);
    }

    if (map.getSource(this.sourceId)) {
      map.removeSource(this.sourceId);
    }
  }

  show(map: Map, layerParams: LayerParams): void {
    
    let { neighborhoodsData } = layerParams;

    if (neighborhoodsData == null || neighborhoodsData.features.length == 0) {
      return;
    }

    map.addSource(this.sourceId, {
      type: 'geojson',
      data: neighborhoodsData,
      promoteId: 'ogc_fid'
    });

    map.addLayer({
      id: this.lineLayerId,
      type: 'line',
      source: this.sourceId,
      layout: {
        visibility: 'visible',
      },
      paint: {
        'line-color':"red",
        'line-width':2
      },
    });

    map.addLayer({
      id: this.fillLayerId,
      type: 'fill',
      source: this.sourceId,
      layout: {
        visibility: 'visible',
      },
      paint: {
        'fill-color':"rgba(109, 114, 116,0.2)"
      },
    });
  }

  hasData(layerParams: LayerParams): boolean {
    return false;
  }
}
